import { render } from "./SocialFeed.vue?vue&type=template&id=a08b2e62&scoped=true"
import script from "./SocialFeed.vue?vue&type=script&lang=js"
export * from "./SocialFeed.vue?vue&type=script&lang=js"

import "./SocialFeed.vue?vue&type=style&index=0&id=a08b2e62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08b2e62"]])

export default __exports__